export enum InquiryButtonTypeName {
    ASK = "ZAPYTAJ",
    OFFER = "ZAPYTAJ O OFERTĘ",
    PRICE = "ODKRYJ CENĘ",
    PRICES = "ODKRYJ CENY",
    RESERVATION = "Rezerwacja",
    FREE_RESERVATION = "ZAREZERWUJ BEZPŁATNIE",
    ARRANGE_MEETING = "UMÓW SIĘ NA SPOTKANIE",
    INVESTMENT = "ZAPYTAJ DEWELOPERA O OFERTĘ",
    PROMOTIONS = "KONTAKT Z DEWELOPEREM",
    VENDOR = "ZAPYTAJ DEWELOPERA",
    NEGOTIATE = "NEGOCJUJ CENĘ",
    DETAILS = "ZAPYTAJ O SZCZEGÓŁY",
    ASK_FOR_ALL = "ZAPYTAJ O WSZYSTKIE",
    SUBMIT_APPLICATION = "WYŚLIJ",
    SUBMIT_APPLICATION_EMAIL = "WYŚLIJ OFERTĘ NA MAILA",
    SHOW_SIMILAR_OFFERS = "ZOBACZ PODOBNE OFERTY",
    SHOW_SIMILAR_OFFERS_NEARBY = "ZOBACZ PODOBNE W TEJ OKOLICY",
    MOVE_TO_NEXT_STEP = "PRZEJDŹ DALEJ",
    ASK_FOR_FULL_OFFER = "ZAPYTAJ O PEŁNĄ OFERTĘ",
    SEE_DETAILS = "ZOBACZ SZCZEGÓŁY",
    SHOW_MORE = "ZOBACZ WIĘCEJ",
    ASK_FOR_PROMOTION = "ZAPYTAJ O PROMOCJĘ"
}
export enum InquiryButtonTypeName {
    ASK = "ZAPYTAJ",
    OFFER = "ZAPYTAJ O OFERTĘ",
    PRICE = "ODKRYJ CENĘ",
    PRICES = "ODKRYJ CENY",
    RESERVATION = "Rezerwacja",
    FREE_RESERVATION = "ZAREZERWUJ BEZPŁATNIE",
    ARRANGE_MEETING = "UMÓW SIĘ NA SPOTKANIE",
    INVESTMENT = "ZAPYTAJ DEWELOPERA O OFERTĘ",
    PROMOTIONS = "KONTAKT Z DEWELOPEREM",
    VENDOR = "ZAPYTAJ DEWELOPERA",
    NEGOTIATE = "NEGOCJUJ CENĘ",
    DETAILS = "ZAPYTAJ O SZCZEGÓŁY",
    ASK_FOR_ALL = "ZAPYTAJ O WSZYSTKIE",
    SUBMIT_APPLICATION = "WYŚLIJ",
    SUBMIT_APPLICATION_EMAIL = "WYŚLIJ OFERTĘ NA MAILA",
    SHOW_SIMILAR_OFFERS = "ZOBACZ PODOBNE OFERTY",
    SHOW_SIMILAR_OFFERS_NEARBY = "ZOBACZ PODOBNE W TEJ OKOLICY",
    MOVE_TO_NEXT_STEP = "PRZEJDŹ DALEJ",
    ASK_FOR_FULL_OFFER = "ZAPYTAJ O PEŁNĄ OFERTĘ",
    SEE_DETAILS = "ZOBACZ SZCZEGÓŁY",
    SHOW_MORE = "ZOBACZ WIĘCEJ",
    ASK_FOR_PROMOTION = "ZAPYTAJ O PROMOCJĘ"
}
